export enum EComponentType {
  form,
  dialog,
}

export interface IDynamicComponent {
  component: any;
  type: EComponentType;
}
